<img class="card"
     role="presentation"
     auto="none"
     [use]="card"
     [query]="{ height:30 }"
     *ngFor="let card of menu?.paymentOptions" />
